export default __webpack_public_path__ + "static/media/logoWebcollector.96a60c92.svg";